export default __webpack_public_path__ + "static/media/4-cloudxier-shooper-dashboardoverview.82e996da.jpg";